/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_FoldersInputs */

const en_app_slider_folders = /** @type {(inputs: App_Slider_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders.`)
};

const es_app_slider_folders = /** @type {(inputs: App_Slider_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas.`)
};

/**
* | output |
* | --- |
* | "Folders." |
*
* @param {App_Slider_FoldersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_folders = /** @type {((inputs?: App_Slider_FoldersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_FoldersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_folders(inputs)
	return en_app_slider_folders(inputs)
});